var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('base-notification', {
    attrs: {
      "can-remove": _vm.canRemove,
      "has-icon": false,
      "notification": _vm.notification
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('invitedToPartyBy', {
        userId: _vm.notification.data.inviter,
        userName: _vm.invitingUser.auth ? _vm.invitingUser.auth.local.username : null,
        party: _vm.notification.data.name
      }))
    }
  }), _c('div', {
    staticClass: "notifications-buttons"
  }, [_c('div', {
    staticClass: "btn btn-small btn-success",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.accept();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('accept')) + " ")]), _c('div', {
    staticClass: "btn btn-small btn-danger",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.reject();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('reject')) + " ")])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }